/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle, _path34, _path35, _path36, _path37, _path38, _path39, _circle2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _circle3, _circle4, _circle5, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _circle6, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _circle7, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383;
const didWarnAboutDeprecation = {};
const WatsonHealth3DCursor = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.49,13.12l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,10,14V24a1,1,0,0,0,.52.87l9,5A1,1,0,0,0,20,30a1.05,1.05,0,0,0,.49-.13l9-5A1,1,0,0,0,30,24V14A1,1,0,0,0,29.49,13.12ZM19,27.3l-7-3.89V15.69l7,3.89Zm1-9.45L13.06,14,20,10.14,26.94,14Zm8,5.56L21,27.3V19.58l7-3.89Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCursor.propTypes = iconPropTypes;
}
const WatsonHealth3DCursorAlt = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCursorAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H17V14H15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H14V17H7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V25H15z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H25V17H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCursorAlt.propTypes = iconPropTypes;
}
const WatsonHealth3DCurveAutoColon = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveAutoColon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveAutoColon.propTypes = iconPropTypes;
}
const WatsonHealth3DCurveAutoVessels = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveAutoVessels({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveAutoVessels.propTypes = iconPropTypes;
}
const WatsonHealth3DCurveManual = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveManual({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15,21a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H17V19H15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2a5,5,0,0,0-4.9,4H20a5,5,0,0,0-5,5h2a3,3,0,0,1,3-3h.1A5,5,0,1,0,25,2Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,25,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveManual.propTypes = iconPropTypes;
}
const WatsonHealth3DICa = /*#__PURE__*/React.forwardRef(function WatsonHealth3DICa({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15,14H10a2,2,0,0,1-2-2V4a2,2,0,0,1,.59-1.42A3.57,3.57,0,0,1,10,2h5V4H10v8h5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V14H4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V4H4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,19.11l-6-3a1,1,0,0,0-.9,0l-6,3A1,1,0,0,0,14,20v7a1,1,0,0,0,.55.89l6,3a1,1,0,0,0,.9,0l6-3A1,1,0,0,0,28,27V20A1,1,0,0,0,27.45,19.11Zm-6.45-1L24.76,20,21,21.88,17.24,20Zm-5,3.5,4,2v4.76l-4-2Zm6,6.76V23.62l4-2v4.76Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H19a2,2,0,0,0-2,2V14h2V10h4v4h2V4A2,2,0,0,0,23,2ZM19,8V4h4V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DICa.propTypes = iconPropTypes;
}
const WatsonHealth3DMprToggle = /*#__PURE__*/React.forwardRef(function WatsonHealth3DMprToggle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21L2 30 11 30 11 28 4 28 4 21 2 21z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 2 21 2 21 4 28 4 28 11 30 11z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49,10.13l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,6,11V21a1,1,0,0,0,.51.87l9,5a1,1,0,0,0,1,0l9-5A1,1,0,0,0,26,21V11A1,1,0,0,0,25.49,10.13ZM16,7.14,22.94,11,16,14.86,9.06,11ZM8,12.7l7,3.89V24.3L8,20.41Zm9,11.6V16.59l7-3.89v7.71Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DMprToggle.propTypes = iconPropTypes;
}
const WatsonHealth3DPrintMesh = /*#__PURE__*/React.forwardRef(function WatsonHealth3DPrintMesh({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DPrintMesh.propTypes = iconPropTypes;
}
const WatsonHealth3DSoftware = /*#__PURE__*/React.forwardRef(function WatsonHealth3DSoftware({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49,13.1151l-9-5a1,1,0,0,0-1,0l-9,5A1.0078,1.0078,0,0,0,2,14v9.9951a1,1,0,0,0,.52.87l9,5A1.0045,1.0045,0,0,0,12,30a1.0559,1.0559,0,0,0,.49-.1349l9-5A.9923.9923,0,0,0,22,24V14A1.0079,1.0079,0,0,0,21.49,13.1151ZM11,27.2951l-7-3.89v-7.72l7,3.89Zm1-9.45L5.06,14,12,10.1351l6.94,3.86Zm8,5.56-7,3.89v-7.72l7-3.89Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DSoftware.propTypes = iconPropTypes;
}
const WatsonHealth3rdPartyConnected = /*#__PURE__*/React.forwardRef(function WatsonHealth3rdPartyConnected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealth3rdPartyConnected.propTypes = iconPropTypes;
}
const _4K = /*#__PURE__*/React.forwardRef(function _4K({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  _4K.propTypes = iconPropTypes;
}
const _4KFilled = /*#__PURE__*/React.forwardRef(function _4KFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  _4KFilled.propTypes = iconPropTypes;
}
const AcceptActionUsage = /*#__PURE__*/React.forwardRef(function AcceptActionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.0022,11.0323l-15.0022-.0323,6.9985,5-6.9956,5h14.9971c.5523,0,1-.4477,1-1v-7.9677c0-.5514-.4464-.9988-.9978-1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AcceptActionUsage.propTypes = iconPropTypes;
}
const Accessibility = /*#__PURE__*/React.forwardRef(function Accessibility({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.55,26.11,26.5,27.63,23.66,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,4,0v4h7V15H19V13a4,4,0,0,0-8,0v1a9,9,0,1,0,8.77,11H17.71A7,7,0,1,1,11,16v3a4,4,0,0,0,4,4h7.34l3.16,7.37,4.95-2.48Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8A3.5,3.5,0,1,1,19,4.5,3.5,3.5,0,0,1,15.5,8Zm0-5A1.5,1.5,0,1,0,17,4.5,1.5,1.5,0,0,0,15.5,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Accessibility.propTypes = iconPropTypes;
}
const AccessibilityAlt = /*#__PURE__*/React.forwardRef(function AccessibilityAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccessibilityAlt.propTypes = iconPropTypes;
}
const AccessibilityColor = /*#__PURE__*/React.forwardRef(function AccessibilityColor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccessibilityColor.propTypes = iconPropTypes;
}
const AccessibilityColorFilled = /*#__PURE__*/React.forwardRef(function AccessibilityColorFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccessibilityColorFilled.propTypes = iconPropTypes;
}
const Account = /*#__PURE__*/React.forwardRef(function Account({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8,14H19v2H8Zm0,5H21v2H8Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Account.propTypes = iconPropTypes;
}
const AccumulationIce = /*#__PURE__*/React.forwardRef(function AccumulationIce({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8L22 16 23 18 24 16 24 8 22 8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8L18 18 19 20 20 18 20 8 18 8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccumulationIce.propTypes = iconPropTypes;
}
const AccumulationPrecipitation = /*#__PURE__*/React.forwardRef(function AccumulationPrecipitation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V18H16z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V18H20z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V22H16z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L19.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L23.3154,6.11A3.9693,3.9693,0,0,1,24,8.223,3.8978,3.8978,0,0,1,20,12Zm0-7.2368L18.3438,7.2257A1.89,1.89,0,0,0,18,8.223,1.9,1.9,0,0,0,20,10a1.9,1.9,0,0,0,2-1.777,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccumulationPrecipitation.propTypes = iconPropTypes;
}
const AccumulationRain = /*#__PURE__*/React.forwardRef(function AccumulationRain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccumulationRain.propTypes = iconPropTypes;
}
const AccumulationSnow = /*#__PURE__*/React.forwardRef(function AccumulationSnow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V4H12z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H16V6H14z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18V8H16z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H18V4H16z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H14V8H12z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H16V20H14z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V22H16z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H16V24H14z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V12H18z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H22V14H20z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H24V16H22z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H24V12H22z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H20V16H18z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AccumulationSnow.propTypes = iconPropTypes;
}
const ActionDefinition = /*#__PURE__*/React.forwardRef(function ActionDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.98,17.4922c0-2.8734,1.4971-4.68,4.1466-4.68,1.8067,0,2.9939.8603,3.5272,2.2712l-1.8067.8087c-.2065-.7571-.7743-1.3076-1.7206-1.3076-1.2215,0-1.841.8602-1.841,2.1162v1.6345c0,1.2561.6194,2.0992,1.841,2.0992,1.0496,0,1.5657-.6023,1.8927-1.411l1.686.8087c-.5849,1.5829-1.841,2.3744-3.5788,2.3744-2.6496,0-4.1466-1.8238-4.1466-4.7144Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14.623,22.0001l-.9635-3.0626h-4.267l-.9465,3.0626h-2.3055l4.026-12.0096h2.8217l3.9917,12.0096h-2.357Zm-3.0627-9.9449h-.0861l-1.5311,4.9381h3.1659l-1.5486-4.9381Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ActionDefinition.propTypes = iconPropTypes;
}
const ActionUsage = /*#__PURE__*/React.forwardRef(function ActionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.98,17.4921c0-2.8734,1.4971-4.68,4.1466-4.68,1.8067,0,2.9939.8603,3.5272,2.2712l-1.8067.8087c-.2065-.7571-.7743-1.3076-1.7206-1.3076-1.2215,0-1.841.8602-1.841,2.1162v1.6345c0,1.2561.6194,2.0992,1.841,2.0992,1.0496,0,1.5657-.6023,1.8927-1.411l1.686.8087c-.5849,1.5829-1.841,2.3744-3.5788,2.3744-2.6496,0-4.1466-1.8238-4.1466-4.7144Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14.623,22l-.9635-3.0626h-4.267l-.9465,3.0626h-2.3055l4.026-12.0096h2.8217l3.9917,12.0096h-2.357Zm-3.0627-9.9449h-.0861l-1.5311,4.9381h3.1659l-1.5486-4.9381Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ActionUsage.propTypes = iconPropTypes;
}
const Activity = /*#__PURE__*/React.forwardRef(function Activity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Activity.propTypes = iconPropTypes;
}
const Add = /*#__PURE__*/React.forwardRef(function Add({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Add.propTypes = iconPropTypes;
}
const AddAlt = /*#__PURE__*/React.forwardRef(function AddAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddAlt.propTypes = iconPropTypes;
}
const AddChildNode = /*#__PURE__*/React.forwardRef(function AddChildNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20v-8.1c2.28-.46,4-2.48,4-4.9,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,2.41,1.72,4.43,4,4.9v8.1c0,3.31,2.69,6,6,6h1v-2h-1c-2.21,0-4-1.79-4-4ZM6,7c0-1.65,1.35-3,3-3s3,1.35,3,3-1.35,3-3,3-3-1.35-3-3ZM28,24v2h-4v4h-2v-4h-4v-2h4v-4h2v4h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddChildNode.propTypes = iconPropTypes;
}
const AddFilled = /*#__PURE__*/React.forwardRef(function AddFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddFilled.propTypes = iconPropTypes;
}
const AddLarge = /*#__PURE__*/React.forwardRef(function AddLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 5 15 5 15 15 5 15 5 17 15 17 15 27 17 27 17 17 27 17 27 15 17 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddLarge.propTypes = iconPropTypes;
}
const AddParentNode = /*#__PURE__*/React.forwardRef(function AddParentNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8h-4v-2h4V2h2v4h4v2h-4v4h-2v-4ZM28,25c0,2.76-2.24,5-5,5-2.42,0-4.44-1.72-4.9-4h-4.1c-3.31,0-6-2.69-6-6v-5h2v5c0,2.21,1.79,4,4,4h4.1c.47-2.28,2.49-4,4.9-4,2.76,0,5,2.24,5,5ZM26,25c0-1.65-1.35-3-3-3s-3,1.35-3,3,1.35,3,3,3,3-1.35,3-3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddParentNode.propTypes = iconPropTypes;
}
const AddComment = /*#__PURE__*/React.forwardRef(function AddComment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AddComment.propTypes = iconPropTypes;
}
const AgricultureAnalytics = /*#__PURE__*/React.forwardRef(function AgricultureAnalytics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.251,21.3691l2.1943,1.4629A1,1,0,0,0,27.8,22.6l3-4-1.6-1.2-2.4326,3.2437L24.5547,19.168a1,1,0,0,0-1.3687.2509L20,23.8789V16H18V26a2.0023,2.0023,0,0,0,2,2H30V26H20.9434Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H16V23H2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H16V28H2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16V11h1a4.0046,4.0046,0,0,0,4-4V4H13a3.9782,3.9782,0,0,0-2.7468,1.1066A6.0033,6.0033,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.0019,2.0019,0,0,1,13,6ZM8,9A4.0046,4.0046,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AgricultureAnalytics.propTypes = iconPropTypes;
}
const Ai = /*#__PURE__*/React.forwardRef(function Ai({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["Ai"]) {
      didWarnAboutDeprecation["Ai"] = true;
      console.warn("Icon should not be used. Teams should use the Carbon AILabel component.. As a result, the Ai component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,9h-4c-1.103,0-2,.897-2,2v12h2v-5h4v5h2v-12c0-1.103-.897-2-2-2Zm-4,7v-5h4v5h-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ai.propTypes = iconPropTypes;
}
const AiBusinessImpactAssessment = /*#__PURE__*/React.forwardRef(function AiBusinessImpactAssessment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23H26V31H24z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21H30V31H28z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27H22V31H20z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18,20v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5005,20h2l-3.5005-11h-3l-3.4966,11h1.9988l.6018-2h4.7781l.6184,2ZM9.7058,16l1.6284-5.4111.2559-.0024,1.6736,5.4136h-3.5579Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30L0 30 0 0 30 0 30 17 28 17 28 2 2 2 2 28 17 28 17 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiBusinessImpactAssessment.propTypes = iconPropTypes;
}
const AiFinancialSustainabilityCheck = /*#__PURE__*/React.forwardRef(function AiFinancialSustainabilityCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M16 23.4142L11.293 18.7072 12.707 17.2928 16 20.5858 27.293 9.2928 28.707 10.7072 16 23.4142z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12.707,8.7073l-1.4141-1.4141-4.2928,4.2928-2.5861-2.5863,4.293-4.2925-1.4141-1.4141-5,4.9995c-.1875.1875-.293.4419-.293.707s.1055.5195.293.707l7,7.0005,1.4141-1.4141-2.2929-2.293,4.2929-4.2929Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c-7.7197,0-14-6.2804-14-14h2c0,6.6168,5.3833,12,12,12s12-5.3832,12-12h2c0,7.7196-6.2803,14-14,14Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24.3076,7.3407c-2.2446-2.1543-5.1948-3.3407-8.3076-3.3407-.9365,0-1.8682.108-2.77.321l-.46-1.9463c1.0522-.2487,2.1387-.3748,3.23-.3748,3.6313,0,7.0737,1.3843,9.6924,3.8978l-1.3848,1.4429Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiFinancialSustainabilityCheck.propTypes = iconPropTypes;
}
const AiGenerate = /*#__PURE__*/React.forwardRef(function AiGenerate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,22v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15.5005,22h2l-3.5005-11h-3l-3.4966,11h1.9988l.6018-2h4.7781l.6184,2Zm-4.7947-4l1.6284-5.4111.2559-.0024,1.6736,5.4136h-3.5579Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M32 4L28 4 28 0 26 0 26 4 22 4 22 6 26 6 26 10 28 10 28 6 32 6 32 4z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 12H32V14H30z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M18 0H20V2H18z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M32 32L0 32 0 0 14 0 14 2 2 2 2 30 30 30 30 18 32 18 32 32z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiGenerate.propTypes = iconPropTypes;
}
const AiGovernanceLifecycle = /*#__PURE__*/React.forwardRef(function AiGovernanceLifecycle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0,1.9229-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-3-10v4.4678c0,1.1533.6738,2.2178,1.7168,2.7109l1.2832.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7109v-4.4678h-6Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1208,17.6562c.5305-.3594.8792-.9673.8792-1.6562,0-1.1045-.8955-2-2-2s-2,.8955-2,2c0,.7886.4607,1.4644,1.124,1.79.6792,5.334,4.3472,9.8477,9.5686,11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m29.3247,20.3076l-1.9033-.6152c-1.4329,4.4355-5.2461,7.5645-9.7651,8.1865-.3596-.5303-.967-.8789-1.6562-.8789-1.1045,0-2,.8955-2,2s.8955,2,2,2c.7888,0,1.4644-.4604,1.7898-1.124,5.334-.6792,9.8479-4.3472,11.5349-9.5684Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m29.876,14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147,1.9033c4.4355,1.4326,7.5642,5.2461,8.1865,9.7651-.5305.3594-.8792.9673-.8792,1.6562,0,1.1045.8955,2,2,2s2-.8955,2-2c0-.7886-.4604-1.4644-1.124-1.79Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.7888,0-1.4644.4604-1.7898,1.124-5.334.6792-9.8479,4.3472-11.5349,9.5684l1.9033.6152c1.4329-4.4355,5.2461-7.5645,9.7651-8.1865.3596.5303.967.8789,1.6562.8789,1.1045,0,2-.8955,2-2s-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiGovernanceLifecycle.propTypes = iconPropTypes;
}
const AiGovernanceTracked = /*#__PURE__*/React.forwardRef(function AiGovernanceTracked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.5898L20.41 24.9999 19 26.41 23 30.41 31 22.41 29.5899 21 23 27.5898z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0,1.9229-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-3-10v4.4678c0,1.1533.6738,2.2178,1.7168,2.7109l1.2832.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7109v-4.4678h-6Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1208,17.6562c.5305-.3594.8792-.9673.8792-1.6562,0-1.1045-.8955-2-2-2s-2,.8955-2,2c0,.7886.4607,1.4644,1.124,1.79.6792,5.334,4.3472,9.8477,9.5686,11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m29.876,14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147,1.9033c4.4355,1.4326,7.5642,5.2461,8.1865,9.7651-.5305.3594-.8792.9673-.8792,1.6562,0,1.1045.8955,2,2,2s2-.8955,2-2c0-.7886-.4604-1.4644-1.124-1.79Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.7888,0-1.4644.4604-1.7898,1.124-5.334.6792-9.8479,4.3472-11.5349,9.5684l1.9033.6152c1.4329-4.4355,5.2461-7.5645,9.7651-8.1865.3596.5303.967.8789,1.6562.8789,1.1045,0,2-.8955,2-2s-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiGovernanceTracked.propTypes = iconPropTypes;
}
const AiGovernanceUntracked = /*#__PURE__*/React.forwardRef(function AiGovernanceUntracked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4102 26L31 22.4102 29.5901 21 26 24.5898 22.4102 21 21 22.4102 24.5901 26 21 29.5898 22.4102 31 26 27.4102 29.5901 31 31 29.5898 27.4102 26z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0,1.9229-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-3-10v4.4678c0,1.1533.6738,2.2178,1.7168,2.7109l1.2832.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7109v-4.4678h-6Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1208,17.6562c.5305-.3594.8792-.9673.8792-1.6562,0-1.1045-.8955-2-2-2s-2,.8955-2,2c0,.7886.4607,1.4644,1.124,1.79.6792,5.334,4.3472,9.8477,9.5686,11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m29.876,14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147,1.9033c4.4355,1.4326,7.5642,5.2461,8.1865,9.7651-.5305.3594-.8792.9673-.8792,1.6562,0,1.1045.8955,2,2,2s2-.8955,2-2c0-.7886-.4604-1.4644-1.124-1.79Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.7888,0-1.4644.4604-1.7898,1.124-5.334.6792-9.8479,4.3472-11.5349,9.5684l1.9033.6152c1.4329-4.4355,5.2461-7.5645,9.7651-8.1865.3596.5303.967.8789,1.6562.8789,1.1045,0,2-.8955,2-2s-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiGovernanceUntracked.propTypes = iconPropTypes;
}
const AiLabel = /*#__PURE__*/React.forwardRef(function AiLabel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5005,21h2l-3.5005-11h-3l-3.4966,11h1.9988l.6018-2h4.7781l.6184,2ZM10.7058,17l1.6284-5.4111.2559-.0024,1.6736,5.4136h-3.5579Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M32,32H0V0h32v32ZM2,30h28V2H2v28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiLabel.propTypes = iconPropTypes;
}
const AiLaunch = /*#__PURE__*/React.forwardRef(function AiLaunch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15,19l-1.4141,1.4141,3.5859,3.5859H4v-13h-2v13c0,1.1046.8954,2,2,2h13.1719l-3.5859,3.5859,1.4141,1.4141,6-6-6-6Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,18v-2h2V4h-2v-2h6v2h-2v12h2v2h-6Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,18h2l-5.5-16-3,.0088-5.5,15.9912h2l1.3333-4h7.3335l1.3333,4Zm-8-6l3-9,3,9h-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiLaunch.propTypes = iconPropTypes;
}
const AiRecommend = /*#__PURE__*/React.forwardRef(function AiRecommend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m18,20v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14.5005,20h2l-3.5005-11h-3l-3.4966,11h1.9988l.6018-2h4.7781l.6184,2Zm-4.7947-4l1.6284-5.4111.2559-.0024,1.6736,5.4136h-3.5579Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26.2171,21l-1.7871,3.621-3.9958.5806,2.8914,2.8188-.6827,3.9796,3.5741-1.879,3.5741,1.879-.6827-3.9796,2.8914-2.8186-3.9958-.5808-1.7871-3.621Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17 30L0 30 0 0 30 0 30 17 28 17 28 2 2 2 2 28 17 28 17 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AiRecommend.propTypes = iconPropTypes;
}
const WatsonHealthAiResults = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResults({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5.9908,5.9908,0,0,0,9.4712,4.8853L28.586,16,30,14.586l-3.115-3.1148A5.997,5.997,0,1,0,16,8Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,18,8Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0055,8.0055,0,0,1,6-7.7373L13.6138,2.3A10.0088,10.0088,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0493,16a9.5991,9.5991,0,0,1-1.8716,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857a10.9664,10.9664,0,0,0,2.3686-2.8331Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResults.propTypes = iconPropTypes;
}
const WatsonHealthAiResultsHigh = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsHigh({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0488,16a9.6136,9.6136,0,0,1-1.8711,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9886,9.9886,0,0,0,25.2815,16Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4a7.9279,7.9279,0,0,1,3.69.9106l.8958-1.791A9.99,9.99,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851,7.1851,0,0,1,8,12,8.0092,8.0092,0,0,1,16,4Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H19a1,1,0,0,1-.8945-1.4473l5-10a1,1,0,0,1,1.7888,0l5,10A1,1,0,0,1,29,14Zm-8.3818-2h6.7636L24,5.2361Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsHigh.propTypes = iconPropTypes;
}
const WatsonHealthAiResultsLow = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsLow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,14ZM24,4a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,4Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsLow.propTypes = iconPropTypes;
}
const WatsonHealthAiResultsMedium = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsMedium({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14H20a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,14ZM20,4v8h8V4Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsMedium.propTypes = iconPropTypes;
}
const WatsonHealthAiResultsUrgent = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsUrgent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H22V9H20z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,21,11Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H28V9H26z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,27,11Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsUrgent.propTypes = iconPropTypes;
}
const WatsonHealthAiResultsVeryHigh = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsVeryHigh({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H26V9H24z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,25,11Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0488,16a9.6136,9.6136,0,0,1-1.8711,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9886,9.9886,0,0,0,25.2815,16Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4a7.94,7.94,0,0,1,4,1.0825V2.8408A9.9887,9.9887,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851,7.1851,0,0,1,8,12,8.0092,8.0092,0,0,1,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsVeryHigh.propTypes = iconPropTypes;
}
const WatsonHealthAiStatus = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14a1,1,0,0,1-.8945-.5527L17.3818,10H14V8h4a1,1,0,0,1,.8945.5527L20,10.7639l3.1055-6.2112a1.0416,1.0416,0,0,1,1.789,0L26.6182,8H30v2H26a1,1,0,0,1-.8945-.5527L24,7.2361l-3.1055,6.2112A1,1,0,0,1,20,14Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatus.propTypes = iconPropTypes;
}
const WatsonHealthAiStatusComplete = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusComplete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8,14a7.28,7.28,0,0,1-2.6219,4.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.1426,9.1426,0,0,0,25.8389,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusComplete.propTypes = iconPropTypes;
}
const WatsonHealthAiStatusFailed = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusFailed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8,14a7.28,7.28,0,0,1-2.6219,4.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.1426,9.1426,0,0,0,25.8389,14Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusFailed.propTypes = iconPropTypes;
}
const WatsonHealthAiStatusInProgress = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusInProgress({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1777,18.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12H24A7.2032,7.2032,0,0,1,21.1777,18.1426Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "7.5",
    r: "1.5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "7.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "7.5",
    r: "1.5"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusInProgress.propTypes = iconPropTypes;
}
const WatsonHealthAiStatusQueued = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusQueued({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1777,18.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12H24A7.2032,7.2032,0,0,1,21.1777,18.1426Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H28V8H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusQueued.propTypes = iconPropTypes;
}
const WatsonHealthAiStatusRejected = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusRejected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,8ZM28,8a3.9521,3.9521,0,0,1-.5669,2.019L21.981,4.5669A3.9529,3.9529,0,0,1,24,4,4.0045,4.0045,0,0,1,28,8ZM20,8a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,12,4.0045,4.0045,0,0,1,20,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusRejected.propTypes = iconPropTypes;
}
const AirlineDigitalGate = /*#__PURE__*/React.forwardRef(function AirlineDigitalGate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0058,5.0058,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9658,11.7413a1.0007,1.0007,0,0,0-1.2246-.707l-3.0861.826L24,7l-1,.2676,1.4584,5.4483-2.7663.7405L20,11.2066l-1,.2676.9337,3.4883a.9993.9993,0,0,0,1.2246.707l10.1005-2.7036A1,1,0,0,0,31.9658,11.7413Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirlineDigitalGate.propTypes = iconPropTypes;
}
const AirlineManageGates = /*#__PURE__*/React.forwardRef(function AirlineManageGates({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirlineManageGates.propTypes = iconPropTypes;
}
const AirlinePassengerCare = /*#__PURE__*/React.forwardRef(function AirlinePassengerCare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,8a2.6616,2.6616,0,0,0-1.9079.8058L25,9.2112l-.3951-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25,17l4.2108-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirlinePassengerCare.propTypes = iconPropTypes;
}
const AirlineRapidBoard = /*#__PURE__*/React.forwardRef(function AirlineRapidBoard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8L28 8 28 6 26 6 26 4 30 4 30 8z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4L23 4 23 6 21 6 21 8 19 8 19 4z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H30V15H28z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11H28V13H26z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirlineRapidBoard.propTypes = iconPropTypes;
}
const Airplay = /*#__PURE__*/React.forwardRef(function Airplay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Airplay.propTypes = iconPropTypes;
}
const AirplayFilled = /*#__PURE__*/React.forwardRef(function AirplayFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirplayFilled.propTypes = iconPropTypes;
}
const Airport_01 = /*#__PURE__*/React.forwardRef(function Airport_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Airport_01.propTypes = iconPropTypes;
}
const Airport_02 = /*#__PURE__*/React.forwardRef(function Airport_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Airport_02.propTypes = iconPropTypes;
}
const AirportLocation = /*#__PURE__*/React.forwardRef(function AirportLocation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AirportLocation.propTypes = iconPropTypes;
}
const Alarm = /*#__PURE__*/React.forwardRef(function Alarm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Alarm.propTypes = iconPropTypes;
}
const AlarmAdd = /*#__PURE__*/React.forwardRef(function AlarmAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlarmAdd.propTypes = iconPropTypes;
}
const AlarmSubtract = /*#__PURE__*/React.forwardRef(function AlarmSubtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H21V18H11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlarmSubtract.propTypes = iconPropTypes;
}
const AlignHorizontalCenter = /*#__PURE__*/React.forwardRef(function AlignHorizontalCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignHorizontalCenter.propTypes = iconPropTypes;
}
const AlignHorizontalLeft = /*#__PURE__*/React.forwardRef(function AlignHorizontalLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H11a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,26Zm0-6.0012L11,20v4H26Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14H11a2.0023,2.0023,0,0,1-2-2V8a2.0023,2.0023,0,0,1,2-2h7a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,18,14Zm0-6.0012L11,8v4h7Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V30H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignHorizontalLeft.propTypes = iconPropTypes;
}
const AlignHorizontalRight = /*#__PURE__*/React.forwardRef(function AlignHorizontalRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M4,24V20a2.0023,2.0023,0,0,1,2-2H21a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H6A2.0023,2.0023,0,0,1,4,24Zm2,0H21V20L6,19.9988Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12V8a2.0023,2.0023,0,0,1,2-2h7a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H14A2.0023,2.0023,0,0,1,12,12Zm2,0h7V8l-7-.0012Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H28V30H26z",
    transform: "rotate(-180 27 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignHorizontalRight.propTypes = iconPropTypes;
}
const AlignVerticalBottom = /*#__PURE__*/React.forwardRef(function AlignVerticalBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M24,23H20a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v7A2.0023,2.0023,0,0,1,24,23Zm-4-9v7h4.0012L24,14Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23H8a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,8,4h4a2.0023,2.0023,0,0,1,2,2V21A2.0023,2.0023,0,0,1,12,23ZM8,6V21h4.0012L12,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignVerticalBottom.propTypes = iconPropTypes;
}
const AlignVerticalCenter = /*#__PURE__*/React.forwardRef(function AlignVerticalCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignVerticalCenter.propTypes = iconPropTypes;
}
const AlignVerticalTop = /*#__PURE__*/React.forwardRef(function AlignVerticalTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20H20a2.0023,2.0023,0,0,1-2-2V11a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v7A2.0023,2.0023,0,0,1,24,20Zm-4-9v7h4.0012L24,11Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8a2.0023,2.0023,0,0,1-2-2V11A2.0023,2.0023,0,0,1,8,9h4a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,12,28ZM8,11V26h4.0012L12,11Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H30V6H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignVerticalTop.propTypes = iconPropTypes;
}
const AlignBoxBottomCenter = /*#__PURE__*/React.forwardRef(function AlignBoxBottomCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H22V20H10z",
    transform: "rotate(-180 16 19)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23H20V25H12z",
    transform: "rotate(-180 16 24)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomCenter.propTypes = iconPropTypes;
}
const AlignBoxBottomLeft = /*#__PURE__*/React.forwardRef(function AlignBoxBottomLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H20V20H9z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23H16V25H9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomLeft.propTypes = iconPropTypes;
}
const AlignBoxBottomRight = /*#__PURE__*/React.forwardRef(function AlignBoxBottomRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H23V20H12z",
    transform: "rotate(-180 17.5 19)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23H23V25H16z",
    transform: "rotate(-180 19.5 24)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomRight.propTypes = iconPropTypes;
}
const AlignBoxMiddleCenter = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10z",
    transform: "rotate(-180 16 14)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H20V20H12z",
    transform: "rotate(-180 16 19)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleCenter.propTypes = iconPropTypes;
}
const AlignBoxMiddleLeft = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H20V15H9z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H16V20H9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleLeft.propTypes = iconPropTypes;
}
const AlignBoxMiddleRight = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H23V15H12z",
    transform: "rotate(-180 17.5 14)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H23V20H16z",
    transform: "rotate(-180 19.5 19)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleRight.propTypes = iconPropTypes;
}
const AlignBoxTopCenter = /*#__PURE__*/React.forwardRef(function AlignBoxTopCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7H22V9H10z",
    transform: "rotate(-180 16 8)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V14H12z",
    transform: "rotate(-180 16 13)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxTopCenter.propTypes = iconPropTypes;
}
const AlignBoxTopLeft = /*#__PURE__*/React.forwardRef(function AlignBoxTopLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H20V9H9z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H16V14H9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxTopLeft.propTypes = iconPropTypes;
}
const AlignBoxTopRight = /*#__PURE__*/React.forwardRef(function AlignBoxTopRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7H23V9H12z",
    transform: "rotate(-180 17.5 8)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H23V14H16z",
    transform: "rotate(-180 19.5 13)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AlignBoxTopRight.propTypes = iconPropTypes;
}
const Analytics = /*#__PURE__*/React.forwardRef(function Analytics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Analytics.propTypes = iconPropTypes;
}
const AnalyticsCustom = /*#__PURE__*/React.forwardRef(function AnalyticsCustom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H23V6h3.5859L19,13.5859,14.707,9.293a1,1,0,0,0-1.414,0L6,16.5859,7.4141,18,14,11.4141l4.293,4.2929a1,1,0,0,0,1.414,0L28,7.4141V11h2Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AnalyticsCustom.propTypes = iconPropTypes;
}
const AnalyticsReference = /*#__PURE__*/React.forwardRef(function AnalyticsReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H23V6h3.5859L19,13.5859,14.707,9.293a1,1,0,0,0-1.414,0L8,14.5858,9.4142,16,14,11.4141l4.293,4.2929a1,1,0,0,0,1.414,0L28,7.4141V11h2Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V16H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AnalyticsReference.propTypes = iconPropTypes;
}
const Anchor = /*#__PURE__*/React.forwardRef(function Anchor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2.257 25.5H8.742V27.5H2.257z",
    transform: "rotate(-45 5.5 26.5)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M9.257 18.5H15.742V20.5H9.257z",
    transform: "rotate(-45 12.5 19.5)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M16.257 11.5H22.742V13.5H16.257z",
    transform: "rotate(-45 19.5 12.5)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M23.257 4.5H29.742V6.5H23.257z",
    transform: "rotate(-45 26.5 5.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Anchor.propTypes = iconPropTypes;
}
const WatsonHealthAngle = /*#__PURE__*/React.forwardRef(function WatsonHealthAngle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAngle.propTypes = iconPropTypes;
}
const WatsonHealthAnnotationVisibility = /*#__PURE__*/React.forwardRef(function WatsonHealthAnnotationVisibility({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H13a3.51,3.51,0,0,0-.88-1.86l3.8-6.64-1.74-1-3.78,6.62A3.35,3.35,0,0,0,9.5,17a3.5,3.5,0,1,0,3.15,5H21ZM9.5,22A1.5,1.5,0,1,1,11,20.5,1.5,1.5,0,0,1,9.5,22Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H26V10H19z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAnnotationVisibility.propTypes = iconPropTypes;
}
const Aperture = /*#__PURE__*/React.forwardRef(function Aperture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Aperture.propTypes = iconPropTypes;
}
const Api = /*#__PURE__*/React.forwardRef(function Api({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Api.propTypes = iconPropTypes;
}
const Api_1 = /*#__PURE__*/React.forwardRef(function Api_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9H4a2,2,0,0,0-2,2V23H4V18H8v5h2V11A2,2,0,0,0,8,9ZM4,16V11H8v5Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Api_1.propTypes = iconPropTypes;
}
const ApiKey = /*#__PURE__*/React.forwardRef(function ApiKey({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,26c-.178,0-.3472.0308-.5115.0742l-1.0554-1.0552c.3516-.5947.5669-1.2798.5669-2.019s-.2153-1.4243-.5669-2.019l1.0554-1.0552c.1643.0435.3335.0742.5115.0742,1.1045,0,2-.8955,2-2s-.8955-2-2-2-2,.8955-2,2c0,.1777.0308.3472.0742.5117l-1.0552,1.0552c-.595-.3516-1.2795-.5669-2.019-.5669s-1.4241.2153-2.019.5669l-1.0552-1.0552c.0435-.1646.0742-.334.0742-.5117,0-1.1045-.8955-2-2-2s-2,.8955-2,2,.8955,2,2,2c.178,0,.3472-.0308.5115-.0742l1.0554,1.0552c-.3516.5947-.5669,1.2798-.5669,2.019s.2153,1.4243.5669,2.019l-1.0554,1.0552c-.1643-.0435-.3335-.0742-.5115-.0742-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.1777-.0308-.3472-.0742-.5117l1.0552-1.0552c.595.3516,1.2795.5669,2.019.5669s1.4241-.2153,2.019-.5669l1.0552,1.0552c-.0435.1646-.0742.334-.0742.5117,0,1.1045.8955,2,2,2s2-.8955,2-2-.8955-2-2-2Zm-7-3c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2",
    strokeWidth: "0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,2c-4.9626,0-9,4.0371-9,9,0,.7788.0989,1.5469.2944,2.291L2,23.5859v6.4141h6.4143l7-7-2.7073-2.707-1.4141,1.4141,1.2927,1.293-1.5896,1.5898-1.2869-1.2949-1.4185,1.4102,1.2913,1.2988-1.9963,1.9961h-3.5857v-3.5859l9.7122-9.7119.8555-.8677-.1982-.5845c-.2451-.7217-.3694-1.4785-.3694-2.25,0-3.8599,3.1401-7,7-7s7,3.1401,7,7h2c0-4.9629-4.0374-9-9-9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ApiKey.propTypes = iconPropTypes;
}
const App = /*#__PURE__*/React.forwardRef(function App({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V24h2V20h4a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10Zm-4,8V12h4v6Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H12V24h2V20h4a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,18,10Zm-4,8V12h4v6Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V12A2.0023,2.0023,0,0,0,8,10Zm0,8H4V16H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  App.propTypes = iconPropTypes;
}
const AppConnectivity = /*#__PURE__*/React.forwardRef(function AppConnectivity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AppConnectivity.propTypes = iconPropTypes;
}
const Apple = /*#__PURE__*/React.forwardRef(function Apple({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Apple.propTypes = iconPropTypes;
}
const AppleDash = /*#__PURE__*/React.forwardRef(function AppleDash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0825,11.6714l-1.6748-1.0928c-.9062,1.3887-1.3928,3.2305-1.4072,5.3267l2,.0137c.0117-1.7119,.3857-3.1807,1.082-4.2476Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0852,17.8164l-1.9907,.1934c.1887,1.938,.6592,3.6738,1.3982,5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2378,23.7964l-1.5688,1.2402c1.333,1.6865,3.0972,2.7573,4.8396,2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-.7334,0-1.4783,.271-2.1987,.5332-.1809,.0654-.3635,.1318-.5469,.1943l.6426,1.894c.197-.0669,.3936-.1382,.5879-.209,.5576-.2026,1.134-.4126,1.5151-.4126,.3809,0,.9575,.21,1.5149,.4121,.1809,.0659,.3635,.1323,.5466,.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2546,25.9878l.1855,1.9917c1.7456-.1631,3.5178-1.2227,4.8621-2.9072l-1.5632-1.2476c-.9924,1.2437-2.2949,2.0522-3.4844,2.1631Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7004,22.3115l1.7871,.8975c.7449-1.4834,1.2205-3.2178,1.4138-5.1558l-1.9902-.1987c-.1689,1.6938-.5762,3.1934-1.2107,4.457Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821,1.082c.6897,1.0728,1.0576,2.5444,1.064,4.2559l2-.0068Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4h-1c-1.1046,0-2,.8954-2,2v1h1c1.1046,0,2-.8954,2-2v-1Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AppleDash.propTypes = iconPropTypes;
}
const Application = /*#__PURE__*/React.forwardRef(function Application({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H16a2,2,0,0,1,2,2V16A2,2,0,0,1,16,18ZM6,6V16H16V6Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12v4H22V12h4m0-2H22a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22v4H22V22h4m0-2H22a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22v4H12V22h4m0-2H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Application.propTypes = iconPropTypes;
}
const ApplicationMobile = /*#__PURE__*/React.forwardRef(function ApplicationMobile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H27V11H23z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H27V17H23z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7H21V11H17z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H21V17H17z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "14.5",
    cy: "24.5",
    r: "1.5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ApplicationMobile.propTypes = iconPropTypes;
}
const ApplicationVirtual = /*#__PURE__*/React.forwardRef(function ApplicationVirtual({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H21V23H17z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H15V23H11z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25H21V29H17z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25H15V29H11z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ApplicationVirtual.propTypes = iconPropTypes;
}
const ApplicationWeb = /*#__PURE__*/React.forwardRef(function ApplicationWeb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V12H26z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H24V6H20z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H24V12H20z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ApplicationWeb.propTypes = iconPropTypes;
}
const Apps = /*#__PURE__*/React.forwardRef(function Apps({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
      d: "M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Apps.propTypes = iconPropTypes;
}
const Archive = /*#__PURE__*/React.forwardRef(function Archive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19H18V21H14z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Archive.propTypes = iconPropTypes;
}
const Area = /*#__PURE__*/React.forwardRef(function Area({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Area.propTypes = iconPropTypes;
}
const AreaCustom = /*#__PURE__*/React.forwardRef(function AreaCustom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AreaCustom.propTypes = iconPropTypes;
}
const ArithmeticMean = /*#__PURE__*/React.forwardRef(function ArithmeticMean({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L22 9 16 17.5713 10 9 8 9 15 19 8 29 10 29 16 20.4287 22 29 24 29 17 19 24 9z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H24V5H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArithmeticMean.propTypes = iconPropTypes;
}
const ArithmeticMedian = /*#__PURE__*/React.forwardRef(function ArithmeticMedian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L22 9 16 17.5713 10 9 8 9 15 19 8 29 10 29 16 20.4287 22 29 24 29 17 19 24 9z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m20,7c-1.7771,0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977,0-2.449.8629-3.2927,1.707l-1.4146-1.4141c1.0674-1.0675,2.5669-2.293,4.7073-2.293,1.7771,0,3.2314.8726,4.5144,1.6425,1.1636.6981,2.2627,1.3575,3.4856,1.3575,1.3975,0,2.4487-.8629,3.293-1.7072l1.4141,1.4143c-1.0674,1.0675-2.5671,2.2928-4.707,2.2928Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArithmeticMedian.propTypes = iconPropTypes;
}
const Arrange = /*#__PURE__*/React.forwardRef(function Arrange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M30,29H2v-2h28v2ZM27,19H5v2h22v-2ZM24,11H8v2h16v-2ZM21,3h-10v2h10v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Arrange.propTypes = iconPropTypes;
}
const ArrangeHorizontal = /*#__PURE__*/React.forwardRef(function ArrangeHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 3H30V5H2z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,21H5c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h8c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2ZM5,13v6h8v-6H5Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,21h-8c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h8c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2Zm-8-8v6h8v-6h-8Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 27H30V29H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrangeHorizontal.propTypes = iconPropTypes;
}
const ArrangeVertical = /*#__PURE__*/React.forwardRef(function ArrangeVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M27 2H29V30H27z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,15h-8c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h8c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2ZM12,7v6h8v-6h-8Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,17h8c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2h-8c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2Zm8,8v-6h-8v6h8Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M3 2H5V30H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrangeVertical.propTypes = iconPropTypes;
}
const Array = /*#__PURE__*/React.forwardRef(function Array({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M4,5v22c0,1.1.9,2,2,2h4v-2h-4V5h4v-2h-4c-1.1,0-2,.9-2,2ZM26,3h-4v2h4v22h-4v2h4c1.1,0,2-.9,2-2V5c0-1.1-.9-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Array.propTypes = iconPropTypes;
}
const ArrayBooleans = /*#__PURE__*/React.forwardRef(function ArrayBooleans({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2h4v2h-4v4h-2v-4c0-1.1046.8954-2,2-2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2ZM16,16c0-3.3137-2.6863-6-6-6s-6,2.6863-6,6,2.6863,6,6,6,6-2.6863,6-6ZM22,12c-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4-1.7944-4-4-4M22,10c3.3137,0,6,2.6863,6,6s-2.6863,6-6,6-6-2.6863-6-6,2.6863-6,6-6h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrayBooleans.propTypes = iconPropTypes;
}
const ArrayDates = /*#__PURE__*/React.forwardRef(function ArrayDates({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M23,8h-2v-2h-2v2h-6v-2h-2v2h-2c-1.1047,0-2,.8953-2,2v12c0,1.1047.8953,2,2,2h14c1.1047,0,2-.8953,2-2v-12c0-1.1047-.8953-2-2-2ZM9,22v-7h14v7h-14ZM22.9999,13h-13.9999v-3h2v1h2v-1h6v1h2v-1h2v3ZM4,2h4v2h-4v4h-2v-4c0-1.1046.8954-2,2-2ZM30,4v4h-2v-4h-4v-2h4c1.1046,0,2,.8954,2,2ZM8,28v2h-4c-1.1046,0-2-.8954-2-2v-4h2v4h4ZM30,24v4c0,1.1046-.8954,2-2,2h-4v-2h4v-4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrayDates.propTypes = iconPropTypes;
}
const ArrayNumbers = /*#__PURE__*/React.forwardRef(function ArrayNumbers({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M11,19v2h-6v-2h2v-5h-2v-2h2v-1h2v8h2ZM19,19h-4v-2h2c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2ZM25,11h-4v2h4v2h-3v2h3v2h-4v2h4c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2ZM2,4v4h2v-4h4v-2h-4c-1.1046,0-2,.8954-2,2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrayNumbers.propTypes = iconPropTypes;
}
const ArrayObjects = /*#__PURE__*/React.forwardRef(function ArrayObjects({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M10,7h3v2h-3v4c0,1.2002-.5425,2.2661-1.3823,3,.8398.7339,1.3823,1.7998,1.3823,3v4h3v2h-3c-1.103,0-2-.8975-2-2v-4c0-1.1025-.897-2-2-2v-2c1.103,0,2-.8975,2-2v-4c0-1.1025.897-2,2-2ZM24,13v-4c0-1.1025-.897-2-2-2h-3v2h3v4c0,1.2002.5425,2.2661,1.3823,3-.8398.7339-1.3823,1.7998-1.3823,3v4h-3v2h3c1.103,0,2-.8975,2-2v-4c0-1.1025.897-2,2-2v-2c-1.103,0-2-.8975-2-2ZM2,4v4h2v-4h4v-2h-4c-1.1046,0-2,.8954-2,2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrayObjects.propTypes = iconPropTypes;
}
const ArrayStrings = /*#__PURE__*/React.forwardRef(function ArrayStrings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28h4v2h-4c-1.1046,0-2-.8954-2-2v-4h2v4ZM11,13v8h-5c-1.1046,0-2-.8954-2-2v-2c0-1.1046.8954-2,2-2h3v-2h-4v-2h4c1.1025,0,2,.897,2,2ZM9,17h-3v2h3v-2ZM4,4h4v-2h-4c-1.1046,0-2,.8954-2,2v4h2v-4ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM28,28h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2v4ZM28,21v-2h-4v-6h4v-2h-4c-1.1025,0-2,.897-2,2v6c0,1.1025.8975,2,2,2h4ZM20,13v6c0,1.1025-.8975,2-2,2h-5v-13h2v3h3c1.1025,0,2,.897,2,2ZM18,13h-3v6h3v-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrayStrings.propTypes = iconPropTypes;
}
const Arrival = /*#__PURE__*/React.forwardRef(function Arrival({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M17.21,5.23l1.39.38,1,11.29,5.87,1.57A2,2,0,0,1,27,20.62a1.88,1.88,0,0,1-1.37,1.52,2,2,0,0,1-1,0l-18.7-5a1.89,1.89,0,0,1-1.33-2.3L6.35,8.34l1.44.38L8.4,13.9l6,1.62L17.21,5.23m-1-2.2a1,1,0,0,0-.68.69L13,13.07l-2.81-.75L9.69,7.79A1,1,0,0,0,9,7L5.87,6.14a.94.94,0,0,0-.5,0,1,1,0,0,0-.68.68l-2,7.49a3.87,3.87,0,0,0,2.74,4.74l18.71,5A3.87,3.87,0,0,0,29,21a4,4,0,0,0-3-4.42l-4.52-1.21L20.53,4.71a1,1,0,0,0-.72-.85L16.73,3a1.06,1.06,0,0,0-.5,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Arrival.propTypes = iconPropTypes;
}
const WatsonHealthArrowAnnotation = /*#__PURE__*/React.forwardRef(function WatsonHealthArrowAnnotation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H18v2H28V28H12V18H10V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthArrowAnnotation.propTypes = iconPropTypes;
}
const ArrowDown = /*#__PURE__*/React.forwardRef(function ArrowDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
      d: "M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowDown.propTypes = iconPropTypes;
}
const ArrowDownLeft = /*#__PURE__*/React.forwardRef(function ArrowDownLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowDownLeft.propTypes = iconPropTypes;
}
const ArrowDownRight = /*#__PURE__*/React.forwardRef(function ArrowDownRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowDownRight.propTypes = iconPropTypes;
}
const ArrowLeft = /*#__PURE__*/React.forwardRef(function ArrowLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
      d: "M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowLeft.propTypes = iconPropTypes;
}
const ArrowRight = /*#__PURE__*/React.forwardRef(function ArrowRight({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
      d: "M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
      d: "M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
      d: "M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowRight.propTypes = iconPropTypes;
}
const ArrowUp = /*#__PURE__*/React.forwardRef(function ArrowUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
      d: "M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowUp.propTypes = iconPropTypes;
}
const ArrowUpLeft = /*#__PURE__*/React.forwardRef(function ArrowUpLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowUpLeft.propTypes = iconPropTypes;
}
const ArrowUpRight = /*#__PURE__*/React.forwardRef(function ArrowUpRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowUpRight.propTypes = iconPropTypes;
}

export { AcceptActionUsage, Accessibility, AccessibilityAlt, AccessibilityColor, AccessibilityColorFilled, Account, AccumulationIce, AccumulationPrecipitation, AccumulationRain, AccumulationSnow, ActionDefinition, ActionUsage, Activity, Add, AddAlt, AddChildNode, AddComment, AddFilled, AddLarge, AddParentNode, AgricultureAnalytics, Ai, AiBusinessImpactAssessment, AiFinancialSustainabilityCheck, AiGenerate, AiGovernanceLifecycle, AiGovernanceTracked, AiGovernanceUntracked, AiLabel, AiLaunch, AiRecommend, AirlineDigitalGate, AirlineManageGates, AirlinePassengerCare, AirlineRapidBoard, Airplay, AirplayFilled, AirportLocation, Airport_01, Airport_02, Alarm, AlarmAdd, AlarmSubtract, AlignBoxBottomCenter, AlignBoxBottomLeft, AlignBoxBottomRight, AlignBoxMiddleCenter, AlignBoxMiddleLeft, AlignBoxMiddleRight, AlignBoxTopCenter, AlignBoxTopLeft, AlignBoxTopRight, AlignHorizontalCenter, AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalCenter, AlignVerticalTop, Analytics, AnalyticsCustom, AnalyticsReference, Anchor, Aperture, Api, ApiKey, Api_1, App, AppConnectivity, Apple, AppleDash, Application, ApplicationMobile, ApplicationVirtual, ApplicationWeb, Apps, Archive, Area, AreaCustom, ArithmeticMean, ArithmeticMedian, Arrange, ArrangeHorizontal, ArrangeVertical, Array, ArrayBooleans, ArrayDates, ArrayNumbers, ArrayObjects, ArrayStrings, Arrival, ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowRight, ArrowUp, ArrowUpLeft, ArrowUpRight, WatsonHealth3DCursor, WatsonHealth3DCursorAlt, WatsonHealth3DCurveAutoColon, WatsonHealth3DCurveAutoVessels, WatsonHealth3DCurveManual, WatsonHealth3DICa, WatsonHealth3DMprToggle, WatsonHealth3DPrintMesh, WatsonHealth3DSoftware, WatsonHealth3rdPartyConnected, WatsonHealthAiResults, WatsonHealthAiResultsHigh, WatsonHealthAiResultsLow, WatsonHealthAiResultsMedium, WatsonHealthAiResultsUrgent, WatsonHealthAiResultsVeryHigh, WatsonHealthAiStatus, WatsonHealthAiStatusComplete, WatsonHealthAiStatusFailed, WatsonHealthAiStatusInProgress, WatsonHealthAiStatusQueued, WatsonHealthAiStatusRejected, WatsonHealthAngle, WatsonHealthAnnotationVisibility, WatsonHealthArrowAnnotation, _4K, _4KFilled };
